import { Component, OnInit } from '@angular/core';

import { AwsEnvironment } from '../../aws/environment';
import { BaseModal } from '../../modals/modal-base';
import { SystemInformationService } from '../../systeminformation/systeminformation.service';

@Component({
    selector: 'about-dialog',
    templateUrl: './about-dialog.component.html',
    styleUrls: [
        './about-dialog.component.scss',
        '../../../../node_modules/bootstrap/dist/css/bootstrap.css'
    ]
})

export class AboutDialogComponent extends BaseModal<boolean> implements OnInit {

    deploymentVersion: string = '...';
    azureDeploymentVersion: string = '...';
    awsDeploymentRegion: string = '...';
    azureDeploymentRegion: string = '...';
    botContainerVersion: string = '...';
    uiDeploymentVersion: string = '...';

    constructor(
        private awsEnv: AwsEnvironment,
        private systemInformationService: SystemInformationService
    ) {
        super();
    }

    ngOnInit() {
        this.azureDeploymentRegion = this.awsEnv.getDefaultSourceRegion();
        this.awsDeploymentRegion = this.awsEnv.getApiRegion();
    }


    onActivate(args: any): any {
        this.systemInformationService.getSystemInformation().subscribe(information => {
            this.deploymentVersion = information.Version;
            this.botContainerVersion = information.BotVersion;

            let cluster = information.Clusters.filter(c => c.Region === this.azureDeploymentRegion)[0];
            if (cluster) {
                this.azureDeploymentVersion = cluster.Version;
            }
        });
    }

    onClose(): void {

    }

    onCloseClicked(e: MouseEvent) {
        e.preventDefault();
        this.closeDialog();
    }

}



// WEBPACK FOOTER //
// ./src/app/modals/about/about-dialog.component.ts